// Angular
import { Component, ViewChild, ViewContainerRef } from '@angular/core';

// Formly
import { FieldArrayType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-repeat',
    templateUrl: './repeat.type.component.html'
})
export class FormlyFieldRepeat extends FieldArrayType { }
